export interface WindowWidthStoreType {
  isMobileView: boolean;
}

export enum WindowWidthStoreKind {
  INITIAL = 'INITIAL',
}

export interface WindowWidthStoreAction {
  type: WindowWidthStoreKind;
  payload: WindowWidthStoreType;
}
